import { render, staticRenderFns } from "./ContactModuleRules.vue?vue&type=template&id=553305c1&scoped=true"
import script from "./ContactModuleRules.vue?vue&type=script&lang=js"
export * from "./ContactModuleRules.vue?vue&type=script&lang=js"
import style0 from "./ContactModuleRules.vue?vue&type=style&index=0&id=553305c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553305c1",
  null
  
)

export default component.exports